export enum PlanType {
  FREE = 'FREE',
  START = 'START',
  ACCELERATE = 'ACCELERATE',
  SKYROCKET = 'SKYROCKET'
}